import React, { useEffect, useState } from 'react';
import AttemptListing from './AttemptListing';
import { columnTypes } from 'src/components/UI/atoms/ATMTable/ATMTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { setPage, setRowsPerPage, setSearchValue, setIsOpenAddDialog, setIsTableLoading, setItems, setTotalItems, setIsOpenEditDialog } from 'src/redux/slices/AttemptSlice';
import { useChangeStatusAttemptByIdMutation, useDeleteAttemptByIdMutation, useGetAllAttemptDataQuery, } from 'src/services/AttemptService';
import { showConfirmationDialog } from 'src/utils/showConfirmationDialog';
import { showToast } from 'src/utils/showToaster';
import ATMMenu from 'src/components/UI/atoms/ATMMenu/ATMMenu';
import AddAttemptWrapper from '../Add/AddAttemptWrapper';
import EditAttemptWrapper from '../Edit/EditAttemptWrapper';
import { usePermission } from 'src/hooks/usePermission';

type Props = {};

const AttemptListingWrapper = (props: Props) => {
    const dispatch = useDispatch();
    const { items, totalItems, page, rowsPerPage, searchValue,isOpenEditDialog,  isOpenAddDialog, isTableLoading } =
        useSelector((state: RootState) => state.attempt);
    const [deleteAttempt] = useDeleteAttemptByIdMutation()
    const [changeStatusAttempt] = useChangeStatusAttemptByIdMutation()
    const [selectedAttemptId, setSelectedAttemptId] = useState<string>()

    const handleDeleteAttempt = (row: string) => {
        showConfirmationDialog({
            title: "Hands Up",
            text: "Are you sure want to delete this Attempt ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
                if (result?.isConfirmed) {
                    deleteAttempt(row).then((res: any) => {
                        if (res.error) {
                            showToast("error", res?.error?.data?.message);
                        } else {
                            showToast("success", res?.data?.message);
                        }
                    });
                }
            },
        });
    };

    const handleChangeStatusAttempt = (row: string) => {
        showConfirmationDialog({
            title: "Hands Up",
            text: "Are you sure want to change status of this Attempt ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
                if (result?.isConfirmed) {
                    changeStatusAttempt({ id: row }).then((res: any) => {
                        if (res.error) {
                            showToast("error", res?.error?.data?.message);
                        } else {
                            showToast("success", res?.data?.message);
                        }
                    });
                }
            },
        });
    };

const moduleName = "ATTEMPT";

const canEdit = usePermission(moduleName, "UPDATE");
const canDelete = usePermission(moduleName, "DELETE");
const canActive = usePermission(moduleName, "ACTIVE/DEACTIVE");

const columns: columnTypes[] = [
  { field: 'attempt', headerName: 'Attempt', flex: 'flex-[1_1_0%]' },
  {
    field: "action",
    headerName: "Actions",
    flex: "flex-[1_1_0%]",
    align:"center",
    extraClasses: "",
    renderCell: (row: any) => {
      const options = [];

      if (canEdit) {
        options.push({
          label: "Edit",
          onClick: () => {
            dispatch(setIsOpenEditDialog(true));
            setSelectedAttemptId(row?._id);
          },
        });
      }

      if (canActive) {
        options.push({
          label: "Active/Deactive",
          onClick: () => {
            handleChangeStatusAttempt(row?._id);
          },
        });
      }

      if (canDelete) {
        options.push({
          label: "Delete",
          onClick: () => {
            handleDeleteAttempt(row?._id);
          },
        });
      }

      return <ATMMenu options={options} />;
    },
  },
];





    const { data, isLoading, isFetching } = useGetAllAttemptDataQuery({
        limit: rowsPerPage,
        searchValue: searchValue,
        params: [
            "attempt",
        ],
        page: page,
        filterBy: [],
        dateFilter: {},
        orderBy: "createdAt",
        orderByValue: -1,
        isPaginationRequired: true,
    });

    // Setting Module Data
    useEffect(() => {
        if (isLoading || isFetching) {
            dispatch(setIsTableLoading(true));
        } else {
            dispatch(setItems(data?.data || []));
            dispatch(setIsTableLoading(false));
            dispatch(setTotalItems(data?.totalItem || 0));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, isLoading, isFetching]);

    return (
        <> <div>
            <AttemptListing
                columns={columns}
                rows={items}
                paginationProps={{
                    isTableLoading,
                    totalItems,
                    page,
                    rowsPerPage,
                    searchValue,
                    setPage: (newPage) => dispatch(setPage(newPage)),
                    setRowsPerPage: (newRowsPerPage) => dispatch(setRowsPerPage(newRowsPerPage)),
                    setIsOpenAddDialog: (value) => dispatch(setIsOpenAddDialog(value)),
                    setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
                }}
            />
        </div>
            {isOpenAddDialog ? (
                <AddAttemptWrapper
                    onClose={() => dispatch(setIsOpenAddDialog(false))}
                />
            ) : null}
            {isOpenEditDialog ? (
                <EditAttemptWrapper
                    onClose={() => dispatch(setIsOpenEditDialog(false))}
                    selectedAttemptId={selectedAttemptId || ""}
                />
            ) : null}
        </>
    );
};

export default AttemptListingWrapper;